import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonExternalModule } from '../../common/common-external-module';
import { HeaderComponent } from '../../components/header/header.component';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { GoogleCustomer } from '../../Model/googlecustomer';
import { Subscription } from 'rxjs';
import { LocalStorageService } from '../../services/local-storage.service';
import { UserService } from '../../services/user.service';
import { ApiFactoryEndPoints } from '../../common/api-factory-end-points';
import { ToastService } from '../../services/toast.service';
import { getWindow } from 'ssr-window';
import { ProductService } from '../../services/product.service';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [CommonExternalModule, HeaderComponent],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.css'
})
export class ProfileComponent implements OnInit, OnDestroy {

  profileForm: UntypedFormGroup;
  googleCustomer: GoogleCustomer;
  minDate: string;
  currentUrl: string;

  getProfileSubscription: Subscription;
  onProfileUpdateSubscription: Subscription;

  constructor(
    private localStorage: LocalStorageService,
    private formBuilder: UntypedFormBuilder,
    private userService: UserService,
    private api: ApiFactoryEndPoints,
    private toastService: ToastService,
    // private seoService: SEOService,
    public productService: ProductService
  ) {
    const today = new Date();
    // Subtract 12 years from the current date
    const minYear = today.getFullYear() - 12;
    this.minDate = new Date(minYear, today.getMonth(), today.getDate()).toISOString().split('T')[0];
  }

  ngOnInit(): void {
    this.currentUrl = getWindow().location.hostname
    this.createProfileForm();
    this.getProfileDetails();
    try {
      // const title = 'My Profile | 1 Bake Shop';
      // const desc = 'Manage your account details, orders and preferences at 1 Bake Shop.';
      // this.seoService.updateTitle(title);
      // this.seoService.updateTags([
      //   { name: 'description', content: desc },
      //   { property: 'og:title', content: title },
      //   { property: 'og:description', content: desc }
      // ]);
      // this.seoService.setCanonicalURL();
    } catch (e) { }
  }

  ngOnDestroy(): void {

  }

  createProfileForm() {
    this.profileForm = this.formBuilder.group({
      id: [""],
      idToken: [""],
      name: [""],
      firstName: [""],
      lastName: [""],
      dob: [""],
      provider: [""],
      spouseName: [""],
      spouseDob: [""],
      anniversaryDate: [""],
      email: [null, Validators.compose([Validators.required, Validators.pattern(/^(\d{10}|\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3}))$/),]),],
      phoneNo: ["", [Validators.required, Validators.pattern("[6-9]\\d{9}")]],
    });
  }

  getProfileDetails() {
    this.googleCustomer = JSON.parse(this.localStorage.getItem("google_loggedIn_details"));

    this.getProfileSubscription = this.userService.getProfiledetails(this.api.getGoogleCustomer, this.googleCustomer.email, this.currentUrl)
      .subscribe((data) => {
        console.log(data);
        if (data != null) {
          this.profileForm.patchValue({
            id: data.id,
            name: data.name,
            firstName: data.name,
            lastName: data.name,
            dob: data.dob,
            email: data.email,
            phoneNo: data.phoneNo,
            provider: data.provider,
            spouseName: data.spouseName,
            spouseDob: data.spouseDob,
            anniversaryDate: data.anniversaryDate,
          });
        }
      });
  }

  onProfileUpdateClick() {
    if (this.profileForm.invalid) {
      this.toastService.showErrorToast("Invalid form");
      return;
    }

    this.profileForm.patchValue({
      idToken: this.googleCustomer.idToken,
    });

    // this.onProfileUpdateSubscription = this.userService
    //   .insertProfile(this.api.insertGoogleCustomer, this.profileForm)
    //   .subscribe((data) => {
    //     this.toastService.showSuccessToast("Updated Successfully");
    //   });
  }
}